import React from "react";
import { Skeleton } from "@mui/material/";

const Loader = () => {
  return (
    <div className="hayley-flex hayley-gap-2 hayley-text-xs">
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton key={index} width={64} height={35} variant="rounded" sx={{ borderRadius: "20px" }} />
      ))}
    </div>
  );
};

export const TourSchedulerSkeleton = Loader;
